export class Proofing_MailBodyAPIModel {
  GetProofingMailBody: string = "";
  GetMailBodyData: string = "";
  GetProofingType: string = "";
  GetJournal: string = "";
  GetArticleStage: string = "";
  GetProofingStage: string = "";
  GetMailBodyColumn: string = "";
  AddUpdateMailBody: string = "";
  ProofingMailBodyTableGridAPI: any;
  GetMailBodybyid: any;
  updateMailBodyData: any;
}
